// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getPriceRangesSpecialRequestItemUrl } from "@keller/App/Services/SpecialRequestItemsService";

type HandlerType = ApiHandler<ApiParameter, string>;

export const DispatchBeginGetPricing: HandlerType = props => {};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getPriceRangesSpecialRequestItemUrl();
    } catch (error) {
        return false;
    }
};

export const DispatchCompleteGetPricing: HandlerType = props => {
    props.dispatch({
        type: "xSpecialRequestItemsState/CompleteLoadPriceRange",
        priceRange: props.apiResult,
    } as any);
};

export const chain = [DispatchBeginGetPricing, RequestDataFromApi, DispatchCompleteGetPricing];

const loadSpecialRequestItemsPriceRange = createHandlerChainRunner(chain, "LoadSpecialRequestItemsPriceRange");

export default loadSpecialRequestItemsPriceRange;
